import { Infer, nullable, object, string } from "superstruct";

export const ModCfCustomHtml = object({
  id: string(),
  contentful_id: string(),
  html: object({
    html: string(),
  }),
  customClass: nullable(string()),
});

export type CustomHtmlProps = Infer<typeof ModCfCustomHtml>;
